// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"59d3f7ab","667":"f583553b","977":"a48255b9"}[chunkId] + ".chunk.js";
};